import { render, staticRenderFns } from "./acompanharDespachante.vue?vue&type=template&id=c2863374&scoped=true&"
import script from "./acompanharDespachante.vue?vue&type=script&lang=js&"
export * from "./acompanharDespachante.vue?vue&type=script&lang=js&"
import style0 from "./acompanharDespachante.vue?vue&type=style&index=0&id=c2863374&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2863374",
  null
  
)

export default component.exports